export default {
  state: {
    deductionList: {
      items: [],
      loading: false,
      reload: false
    },
    deductionDelete: {
      show: false,
      item: null
    }
  },
  mutations: {
    setDeductionListItems (state, value) { state.deductionList.items = value },
    addDeductionListItem (state, value) { state.deductionList.items.push(value) },
    setDeductionListLoading (state, value) { state.deductionList.loading = value },
    setDeductionListReload (state, value) { state.deductionList.reload = value },
    setDeductionDeleteShow (state, value) { state.deductionDelete.show = value },
    setDeductionDeleteItem (state, value) { state.deductionDelete.item = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/provider-deductions/deduction-list.js